module.exports = __webpack_public_path__ + "static/media/img_feature_photo3@2x.ce945f00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_feature_photo3@2x.png
// module id = 806
// module chunks = 0